import React from 'react';

const data = [
  {
    category: 'Genes',
    v244: 26798,
    v2511: 29460,
    TotalIncrease: 2662,
    percentIncrease: 9.93,
  },
  {
    category: 'Diseases/traits',
    v244: 39972,
    v2511: 42407,
    TotalIncrease: 2435,
    percentIncrease: 6.09,
  },
  {
    category: 'Variants',
    v244: 728547,
    v2511: 1425623,
    TotalIncrease: 697076,
    percentIncrease: 95.68,
  },
  {
    category: 'Chemicals',
    v244: 4044,
    v2511: 14652,
    TotalIncrease: 10608,
    percentIncrease: 262.31,
  },
  {
    category: 'GDAs',
    v244: 1957356,
    v2511: 1982885,
    TotalIncrease: 25529,
    percentIncrease: 1.3,
  },
  {
    category: 'VDAs',
    v244: 1245570,
    v2511: 4397303,
    TotalIncrease: 3151733,
    percentIncrease: 253.04,
  },
  {
    category: 'Publications',
    v244: 1572260,
    v2511: 1600639,
    TotalIncrease: 28379,
    percentIncrease: 1.8,
  },
];

function StatisticsSummaryTable() {
  return (
    <div>
      <h3 className="mt-5">Summary stats for latest release:</h3>
      <div className="table-responsive">
        <table className="table panther-table" style={{ float: 'middle', margin: '10px 20px 60px 10px' }}>
          <ReleasesTables />
        </table>
      </div>
      <br />
      <img
        src="../../static/images/Release_GenoPheno.svg"
        style={{
          float: 'middle',
        }}
        alt="DISGENET statistics"
      />
    </div>
  );
}

function ReleasesTables() {
  return (
    <>
      {/* <thead className="text-center">
        <tr>
          <th></th>
          <th colSpan="1" className="border-right">
            2024
          </th>
          <th colSpan="1" className="border-right">
            2025
          </th>
          <th colSpan="3"></th>
        </tr>
      </thead> */}
      <thead className="text-center">
        <tr>
          <th></th>
          <th className="border-right">V24.4</th>
          <th className="border-right">V25.1.1</th>
          <th>
            Total increase <br />
            (25.1.1 vs 24.4)
          </th>
          <th>
            % increase <br />
            (25.1.1 vs 24.4)
          </th>
        </tr>
      </thead>
      <tbody className="text-center">
        {data.map((row, index) => (
          <tr key={index}>
            <td className="border-right">
              <strong>{row.category}</strong>
            </td>
            <td className="border-right">{row.v244}</td>
            <td className="border-right">{row.v2511}</td>
            <td>{row.TotalIncrease}</td>
            <td>{row.percentIncrease}</td>
          </tr>
        ))}
      </tbody>
    </>
  );
}

export default StatisticsSummaryTable;
